var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHireUsRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42856 5.71401C3.42856 6.92642 3.91019 8.08919 4.7675 8.94649C5.62481 9.8038 6.78757 10.2854 7.99999 10.2854C9.2124 10.2854 10.3752 9.8038 11.2325 8.94649C12.0898 8.08919 12.5714 6.92642 12.5714 5.71401C12.5714 4.50159 12.0898 3.33883 11.2325 2.48152C10.3752 1.62421 9.2124 1.14258 7.99999 1.14258C6.78757 1.14258 5.62481 1.62421 4.7675 2.48152C3.91019 3.33883 3.42856 4.50159 3.42856 5.71401Z",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.14285 21.7146V19.4289C1.14285 18.2164 1.62448 17.0537 2.48179 16.1964C3.3391 15.3391 4.50186 14.8574 5.71428 14.8574H10.2857C11.3829 14.8574 12.3886 15.2437 13.1771 15.8871",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.29102C16.9833 1.54279 17.8549 2.11467 18.4773 2.91651C19.0997 3.71835 19.4375 4.70454 19.4375 5.71959C19.4375 6.73464 19.0997 7.72082 18.4773 8.52266C17.8549 9.3245 16.9833 9.89639 16 10.1482",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.4277H22.8571",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4286 16V22.8571",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHireUsRequest);
export default __webpack_public_path__ + "static/media/hire-us-request.95c3467373dd68910498c856d8546566.svg";
export { ForwardRef as ReactComponent };